export const ListEmptyComponent = () => {
  return (
    <div>
      <p>No chapters found</p>
    </div>
  );
};
